import { useState } from 'react';
import { styled } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import Box from '@mui/material/Box';

import { FollowTwitter } from './Follow';
import AppDrawer from './Drawer';

import isotype from '../img/8bitpix_400.png';
import './layout.css';

const StyledAppBar = styled(AppBar)({
  backgroundColor: '#164322',
});

const MenuWrapper = styled(Box)({
  '& .MuiButtonBase-root': {
    backgroundColor: 'transparent',
    borderRadius: '4px 0px 0px 4px',
  },
  '& img': {
    width: '36px',
    borderRadius: '0px 4px 4px 0px',
    boxShadow: '0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)',
  },
});

const MenuButton = styled(IconButton)(({ theme }) => ({
  marginRight: theme.spacing(2),
  color: '#fff',
}));

export default function Header() {
  const [open, setOpen] = useState(false);

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  return (
    <>
      <StyledAppBar className="p-3" position="static" color="default">
        <Toolbar>
          <MenuWrapper>
            <MenuButton
              color="inherit"
              aria-label="open drawer"
              onClick={handleDrawerOpen}
              edge="start"
            >
              <MenuIcon />
            </MenuButton>
          </MenuWrapper>
          <Box sx={{ flexGrow: 1 }} />
          <div className="page-logo">
            <img src={isotype} alt="8bitpix" />
          </div>
          <Box sx={{ flexGrow: 1 }} />
          <Box className="row">
            <FollowTwitter />
          </Box>
        </Toolbar>
      </StyledAppBar>
      <AppDrawer open={open} setOpen={setOpen} />
    </>
  );
}
